import { render, staticRenderFns } from "./RequestRemoval.vue?vue&type=template&id=f4c76180"
import script from "./RequestRemoval.vue?vue&type=script&lang=js"
export * from "./RequestRemoval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports